var map = {
	"./3st_enterprise_app.png": "4717",
	"./assist_write.png": "f060",
	"./case_139_email.png": "4aad",
	"./case_360.png": "9843",
	"./case_baidu_netdisk.png": "2381",
	"./case_beihang_university.png": "dc75",
	"./case_deli.png": "eae3",
	"./case_hantu.png": "a7c6",
	"./case_he_fei_xin.png": "8c1f",
	"./case_huijiao_cloud.png": "1148",
	"./client_side.png": "a84b",
	"./docs_edit.png": "15d7",
	"./docs_transform.png": "94ae",
	"./inner_enterprise_app.png": "6bae",
	"./intel_write.png": "8387",
	"./kdocs.png": "a6e2",
	"./language_handle.png": "0c5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "89a6";